import { Price } from 'src/@types/transactions';

const currencySymbols: any = {
  USD: '$',
  NZD: '$',
  AUD: '$',
  GBP: '£',
  CNY: '¥',
  JPY: '¥',
  EUR: '€',
  HKD: '$',
};

export const SUPPORTED_CURRENCIES = [
  "USD",
  "EUR",
  "NZD",
  "AUD",
  "GBP",
  'AED',    'AFN',
  //'ALL',
  //'AMD',
  'ANG',
  //'AOA',
  //'ARS',
  'AWG',    'AZN',    'BAM',
  'BBD',    'BDT',    'BGN',
  //'BIF',
  'BMD',    'BND',    'BOB',    'BRL',
  'BSD',    'BWP',    'BZD',    'CAD',
  //'CDF',
  'CHF',    //'CLP',
  'CNY',
  //'COP',
  //'CRC',
  'CVE',    'CZK',
  'DJF',    'DKK',    'DOP',    'DZD',
  'EGP',    'ETB',    'FJD',
  'FKP',    'GEL',    'GIP',
  'GMD',
  //'GNF',
  'GTQ',    'GYD',
  'HKD',    'HNL',    'HRK',    'HTG',
  'HUF',
  //'IDR',
  'ILS',    'INR',
  'ISK',    'JMD',    'JPY',    'KES',
  'KGS',
  //'KHR',
  'KMF',
  //'KRW',
  'KYD',    'KZT',
  //'LAK',
  //'LBP',
  'LKR',    'LRD',    'LSL',    'MAD',
  'MDL',
  //'MGA',
  'MKD',
  //'MMK',
  //'MNT',
  'MOP',    'MRO',    'MUR',
  'MVR',
  //'MWK',
  'MXN',    'MYR',
  'MZN',    'NAD',    'NGN',    'NIO',
  'NOK',    'NPR',    'PAB',
  'PEN',    'PGK',    'PHP',    'PKR',
  'PLN',
  //'PYG',
  'QAR',    'RON',
  'RSD',    'RUB',
  //'RWF',
  'SAR',
  'SBD',    'SCR',    'SEK',    'SGD',
  'SHP',
  //'SLL',
  //'SOS',
  'SRD',
  //'STD',
  'SZL',    'THB',    'TJS',
  'TOP',    'TRY',    'TTD',    'TWD',
  //'TZS',
  'UAH',
  //'UGX',
  'UYU',
  //'UZS',
  //'VND',
  'VUV',    'WST',
  //'XAF',
  'XCD',
  //'XOF',
  'XPF',
  'YER',    'ZAR',    'ZMW',
];

export const DEFAULT_CURRENCY = 'USD';

const formatPriceTextOnly = (price: Price, hideCurrencySymbol?: boolean) => {
  const symbol = currencySymbols[price.currency.toUpperCase()];
  const number = price.value.toLocaleString(undefined, {
    maximumFractionDigits: price?.zeroDecimalCurrency ? 0 : 2,
    minimumFractionDigits: price?.zeroDecimalCurrency ? 0 : 2
  });

  return symbol && !hideCurrencySymbol
    ? `${symbol}${number} ${price.currency.toUpperCase()}`
    : `${number} ${price.currency.toUpperCase()}`;
};

const formatPricing = (price: Price | null) => {
  if (price) {
    return formatPriceTextOnly(price);
  } else return `$--.--`;
};

export {
  formatPriceTextOnly,
  formatPricing,
};
